import { differenceInBusinessDays, differenceInCalendarDays } from 'date-fns'

const EDIT_MIN_DAYS = 3
const CANCEL_MIN_DAYS = 2

export const isEditCloseDate = (date: Date) =>
  EDIT_MIN_DAYS >= differenceInBusinessDays(date, new Date(Date.now()))

export const isCancelCloseDate = (date: Date) =>
  CANCEL_MIN_DAYS >= differenceInBusinessDays(date, new Date(Date.now()))

export const bookingDurationInDays = (startDate: string, endDate: string) =>
  differenceInCalendarDays(new Date(endDate), new Date(startDate))
